import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { PlanFormContainer, SubmitButton, StpSwpHelper, proceedAfterBseOrder, showAwaitingModal, calcWeekDays } from '../stp-swp-helper';
import { CustomisedHr, FormErrorMessageSpan, InputMintDiv } from 'views/common-styled-components';
import { getQueryParamsFromString, isBtoCFlow, refreshOnHistoryTraversal } from '__utils/common-utils';
import { ENDPOINTS } from 'constants/endpoints';
import { useHistory } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import LoginSelector from 'views/login/login.selector';
import { getEncryptedUserId } from '__utils/common-utils';
import { getDefaultHeaders, post, get } from '__utils/ajax-wrapper';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import resolveURLParams from '__utils/url-params-resolver';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { LayoutContext } from 'components/app-routes';
import { DatePicker, Row, Col } from 'antd';
import { Controller, useForm } from 'react-hook-form';
import useFlashToggler from 'hooks/use-flash-toggler';
import moment from 'moment';
import './index.css';
import { useDeepCompare } from 'hooks/use-deep-memo';
import { SuccessBtnWhiteGreenBorder } from 'components/button';
import { DatepickerIcon } from 'assets/icons/date-picker';
import { AGENT_STATUS } from 'constants/common-constants';
import Checkbox from '__utils/customisedCheckBox';
import CustomTag from 'components/tag';
import { ExclamationFilledIcon } from 'assets/icons/exclamation-icon-filled';
import LoaderSelect from 'components/loader-select';


const CreateNewStp: React.FC = () => {
    const history = useHistory();
    const dateFormat = 'YYYY-MM-DD';
    const location = useLocation();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    const { portfolioDetails } = propsToJS(useSelector(LoginSelector));
    const [destinationFunds, setDestinationFunds] = useState<any>();
    const [selectedFundNetAmount, setSelectedFundNetAmount] = useState<any>();
    const [selectedFundNetUnit, setSelectedFundNetUnit] = useState<any>();
    const [showAwatingStatus, setShowAwatingStatus] = useState<boolean>(false);
    const [dataUnavailableForFreq, setDataUnavailableForFreq] = useState<string>();
    const [enteredDate, setEnteredDate] = useState<any>(moment().add(1, 'days').format(dateFormat));
    const [schemeDataFromPath, setSchemeDataFromPath] = useState<any>();
    const [sourceFundValidations, setSourceFundValidations] = useState<any>();
    const [destionationFundValidations, setDestionationFundValidations] = useState<any>();
    const [showConfirmPopup, setShowConfirmPopup] = useState<any>();
    const [selectedFund, setSelectedFund] = useState<any>();
    const [numberOfInstallments, setNumberOfInstallments] = useState<any>();
    const [transferFreq, setTransferFreq] = useState<number>();
    const [inputValidations, setInputValidations] = useState<any>();
    const [firstOrderTodayFlag, setFirsrOrderTodayFlag] = useState<any>(true);
    const [showSTPloader, setShowSTPloader] = useState<any>(false);
    const [showToFundloader, setShowToFundloader] = useState<any>(false);
    const [fetchToSchemesLoader, setFetchToSchemesLoader] = useState<any>(false);
    const { register, handleSubmit, getValues, formState, trigger, setValue, control, reset, watch } = useForm({ mode: 'onChange' });
    const { errors } = formState;
    const freqObject: any = { 1: "MONTHLY", 3: "QUARTERLY", 52: "WEEKLY", 30: "DAILY" };
    const flash = useFlashToggler();
    const { saveBSEorder } = StpSwpHelper();
    const watchInstAmt = watch("installmentAmount");

    useEffect(() => {
        SetLayoutProps({
            config: { title: 'Setup New STP' }
        });
        Mixpanel.track(getEventName("createNewSTP", "loaded", "mySTPs"));
        const { schemeId,folio } = getQueryParamsFromString(window.location.search);
        schemeId && folio && setSchemeDataFromPath(`${schemeId},${folio}`);
        refreshOnHistoryTraversal(() => reset({}));
        setDataUnavailableForFreq('')
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    useEffect(() => {
        if (portfolioDetails && schemeDataFromPath) {
            setValue('fromSchemeCode', schemeDataFromPath);
            filterFundDetails(schemeDataFromPath);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [useDeepCompare(portfolioDetails),schemeDataFromPath]);

    //purpose: filter portfoilo details using the schemeId in params
    const filterFundDetails = (fromFieldData: string) => {
        const encyptedSchemeId = fromFieldData.split(',')[0];
        const folioNumber = fromFieldData.split(',')[1];
        
        if (encyptedSchemeId) {
            reset({ ...getValues(), toSchemeCode: '', installmentAmount: '', freqType: '', noOfInstallments: '', startDate: undefined, endDate: undefined });
            setDataUnavailableForFreq('')
            setFirsrOrderTodayFlag(true); setInputValidations(null);
           
            const specificFundArray: any[]= portfolioDetails.portfolioSchemes.filter((element: any) => element?.metaData?.schemeId === encyptedSchemeId && element?.folioNo === folioNumber);
            
            setSelectedFundNetAmount(specificFundArray[0]?.currentValue); 
            setSelectedFundNetUnit(specificFundArray[0]?.unitsAllocated); 
 
            setSelectedFund({
                fromSchemeCode: specificFundArray[0]?.portfolioSchemeTransactions[0]?.schemeCode,
                fromSchemeName: specificFundArray[0]?.metaData?.schemeName,
                fromSchemeId: specificFundArray[0]?.metaData?.schemeId,
                folioNo: specificFundArray[0]?.folioNo,
                fromIsin: specificFundArray[0]?.isin
            });
            
            getDestinationSchemes(specificFundArray[0].metaData?.schemeId);
            getSourceFundDetails(specificFundArray[0].metaData?.schemeId)
            trigger('fromSchemeCode');
        }

    }

    //purpose: get list of schemes for to input field of same amc, params: entered from input field, output:stores list in destinationFunds 
    const getDestinationSchemes = (encyptedSchemeId: string) => {
        setFetchToSchemesLoader(true);
        get(`${ENDPOINTS.GET_DESTINATION_FUNDS}?encryptedSchemeId=${encyptedSchemeId}`, getDefaultHeaders(), false)
            .subscribe((response: AjaxResponse | AjaxError) => {
                setFetchToSchemesLoader(false);
                setDestinationFunds(response?.response?.data?.filter((object: any) => object.encryptedSchemeId != encyptedSchemeId));
            }, (error: AjaxError) => {
                flash.error('Something went wrong.Please try again later');
            });
    }

    // purpose: fetch details of source fund,params: schemeId of selected from fund
    const getSourceFundDetails = (encyptedSchemeId: string) => {
        setShowSTPloader(true);
        get(`${ENDPOINTS.GET_STP_VALIDATION_DETAILS}?encryptedSchemeId=${encyptedSchemeId}`, getDefaultHeaders(), false)
            .subscribe((response: AjaxResponse | AjaxError) => {
                setShowSTPloader(false);
                setSourceFundValidations(response?.response?.data);
            }, (error: AjaxError) => {
                flash.error('Something went wrong.Please try again later');
            });
    }

    //purpose: fetch details of source fund,params: schemeId of selected from fund
    const getDestinationFundDetails = (encryptedSchemeId: string) => {
        setShowToFundloader(true);
        reset({ ...getValues(), installmentAmount: '', freqType: '', noOfInstallments: '', startDate: '', endDate: '', firstOrderToday: true });
        setFirsrOrderTodayFlag(true); setInputValidations(null); setDataUnavailableForFreq('')
        get(`${ENDPOINTS.GET_STP_VALIDATION_DETAILS}?encryptedSchemeId=${encryptedSchemeId}`, getDefaultHeaders(), false)
            .subscribe((response: AjaxResponse | AjaxError) => {
                setShowToFundloader(false);
                setDestionationFundValidations(response?.response?.data);
            }, (error: AjaxError) => {
                flash.error('Something went wrong.Please try again later');
            });
    }

    //purpose: called after otp is verified, param: form i/ps , trxnId, o/p: punch bse order
    const onSetupClick = (newStp: any, transactionId: any) => {
        saveBSEorder(transactionId, onBseOrderSuccess, newStp);
    }

    //purpose: punch order, output: shows confirm popup,passes params to be shown in popup
    const onBseOrderSuccess = (stpElem: any) => {
        setShowConfirmPopup({ show: true, onClick: proceedAfterConfirmation, firstOrderToday: stpElem?.firstOrderToday, startDate: stpElem?.startDate });
    }
    //purpose: redirect to stps if ok of awaitng for approval ok clicked
    const awaitingClick = () => {
        setShowAwatingStatus(false);
        history.push('/profile/stps')
    }

    //purpose: redirect to stps if ok CTA of conirm popup clicked
    const proceedAfterConfirmation = () => {
        setShowConfirmPopup({ show: false });
        history.push('/profile/stps');
    }

    const getAllowedDates = (sourceFilteredByFreq: any) => {
        let allowedDatesArr: any[] = [];
        sourceFilteredByFreq.forEach((item: any) => allowedDatesArr.push(item?.astpDates));
        return allowedDatesArr;
    }


    //@purpose - fetch allowed dates for a specific frequency
    const fetchSTPDates = (frequency: string) => {
        if (frequency && sourceFundValidations && destionationFundValidations) {
            setDataUnavailableForFreq(''); setInputValidations(null);
            reset({ ...getValues(), installmentAmount: '', noOfInstallments: '', startDate: '', endDate: '' });
            const sourceFilteredByFreq = sourceFundValidations?.filter((element: any) => element?.astpFrequency === frequency && element?.astpRegOut === 'Y');
            const destinationFilteredByFreq = destionationFundValidations?.filter((element: any) => element?.astpFrequency === frequency && element?.astpRegIn === 'Y');
            if (sourceFilteredByFreq?.length && destinationFilteredByFreq?.length) {
                setInputValidations({
                    minAmt: Math.max(sourceFilteredByFreq[0]?.astpOutMinInstAmt, destinationFilteredByFreq[0]?.astpInMinInstAmt),
                    maxAmt: Math.min(sourceFilteredByFreq[0]?.astpOutMaxInstAmt, destinationFilteredByFreq[0]?.astpInMaxInstAmt),
                    maxInstNo: Math.min(sourceFilteredByFreq[0]?.astpMaxInstlNos, destinationFilteredByFreq[0]?.astpMaxInstlNos),
                    minInstNo: Math.max(sourceFilteredByFreq[0]?.astpMinInstlNos, destinationFilteredByFreq[0]?.astpMinInstlNos),
                    multiplierAmt: destinationFilteredByFreq[0]?.astpOutMultiplierAmt,
                    minGapAllowed: Math.max(destinationFilteredByFreq[0]?.astpMinGap, sourceFilteredByFreq[0]?.astpMinGap),
                    maxGapAllowed: Math.min(destinationFilteredByFreq[0]?.astpMaxGap, sourceFilteredByFreq[0]?.astpMaxGap),
                    allowedDates: getAllowedDates(sourceFilteredByFreq)
                })

            }
            else setDataUnavailableForFreq(frequency)
        }
    }
    //disable dates of datepicker
    const disabledDates = (current: any) => {
        return !current ||
            current.isSameOrBefore(new Date()) ||
            ((getValues('freqType') === '1' || getValues('freqType') === '3') && !inputValidations?.allowedDates?.includes(moment(current).format("D"))) ||
            current.isAfter(moment().add(inputValidations?.maxGapAllowed, 'days')) || current.isBefore(moment().add(inputValidations?.minGapAllowed, 'days')) ||
            (getValues('freqType') === '52' && (current.day() === 0 || current.day() === 6))
    }

    //purpose: register stp call, params: filled data from the form, o/p: show otp popup or awaiting popup
    const onSubmitStpDetails = (stpData: any) => {
        Mixpanel.track(getEventName("createNewSTP", "completed", "mySTPS"));
        const stpSwpRequestObject = {
            ...stpData, folioNo: selectedFund?.folioNo,
            startDate: enteredDate, isBtoCFlow: isBtoCFlow(), trxnType: "STP", totalamount: stpData?.installmentAmount * numberOfInstallments,
            fromSchemeCode: selectedFund?.fromSchemeCode, toSchemeCode: stpData.toSchemeCode.split(',')[1],
            fromIsin: selectedFund?.fromIsin, toIsin: stpData.toSchemeCode.split(',')[0],
            fromSchemeName: selectedFund?.fromSchemeName, toSchemeName: stpData.toSchemeCode.split(',')[2],
            endDate: transferFreq == 30 ? moment(stpData?.endDate).format(dateFormat) : null,
            firstOrderToday: firstOrderTodayFlag ? "Y" : "N",
        };
        post(resolveURLParams(ENDPOINTS.POST_STP_SWP_REGISTRATION, {}, { ucc: getEncryptedUserId() }), stpSwpRequestObject, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.status === 200) {

                    if (response?.response?.data?.agentStatus === AGENT_STATUS.APPROVED.toUpperCase()) {
                        onSetupClick(stpSwpRequestObject, response?.response?.data?.id);
                    }
                    else if (response?.response?.data?.agentStatus === AGENT_STATUS.PENDING.toUpperCase()) setShowAwatingStatus(true);
                    else if (response?.response?.meta?.error) {
                        flash.error(response?.response?.meta?.error);
                    }
                }
                else {
                    flash.error("Failed to create new STP. Please try again later")
                }
            }, (error: AjaxError) => {
                flash.error("Failed to create new STP. Please try again later")
            });
    }

    return (<div>
        <PlanFormContainer isMobile={isMobile}>
            <div>
                <p className="title"> Systematic Transfer Plan (STP) </p>
                <p className={`grey ${isMobile ? 'font14' : 'font16'}`}>Setup regular transfer of your invested amount from one fund to another fund of same AMC.</p>

                <Row justify='space-between'>
                    <Col xs={24} md={18}>
                        <CustomisedHr />
                        <form name="stpDetailsForm" onSubmit={handleSubmit(onSubmitStpDetails)}>
                            <Row gutter={16}>
                                <Col xs={24} md={12}>
                                    <div className="form-group">
                                        <label htmlFor="fromSchemeCode">Transfer from</label>
                                        <br />

                                        <LoaderSelect
                                            name="fromSchemeCode"
                                            isFetchingData={showSTPloader}
                                            style={{ marginTop: "4px" }}
                                            onChange={(fromFundEvent: any) => {
                                                filterFundDetails(fromFundEvent.target.value)
                                            }}
                                            selectRef={register({
                                                required: "Please select the fund you want to transfer from.",
                                            })}
                                            childOptions={
                                                <>
                                                    <option value="" disabled selected={!schemeDataFromPath && true}>Select fund </option>
                                                    {portfolioDetails && portfolioDetails?.portfolioSchemes?.filter((element: any) => element?.stpFlag === 'Y' && element?.unitsAllocated)?.map((element: any, index: number) => (
                                                        <option key={index} value={`${element?.metaData?.schemeId},${element?.folioNo}`}>{element?.metaData?.schemeName?.toLowerCase()}</option>))
                                                    }
                                            </>}
                                        >
                                        </LoaderSelect>

                                        {(errors?.fromSchemeCode) ? <FormErrorMessageSpan>{errors.fromSchemeCode.message}</FormErrorMessageSpan> : null}
                                    </div>
                                </Col>

                                <Col xs={24} md={12}>
                                    <div className="form-group">
                                        <label htmlFor="toSchemeCode">Transfer to</label>
                                        <br />
                                        <LoaderSelect
                                            name="toSchemeCode"
                                            defaultValue={""}
                                            className="shortenedSelect"
                                            style={{ marginTop: "4px" }}
                                            isFetchingData={fetchToSchemesLoader || showToFundloader}
                                            selectRef={register({
                                                required: "Please select the fund you want to transfer to.",
                                            })}
                                            onChange={(toFundEvent: any) => {
                                                getDestinationFundDetails(toFundEvent.target.value.split(',')[3])
                                            }}
                                            childOptions={
                                                <>
                                                    <option value="" disabled selected={!schemeDataFromPath && true}>Select fund </option>
                                                    {destinationFunds && destinationFunds?.map((element: any, index: number) => (
                                                        <option key={index} value={`${element?.schemeIsin},${element?.bseSchemeCode},${element?.schemeName},${element?.encryptedSchemeId}`}>{element?.schemeName?.toLowerCase()}</option>))
                                                    }
                                                </>}
                                        >
                                        </LoaderSelect>

                                        {(errors?.toSchemeCode) ? <FormErrorMessageSpan>{errors.toSchemeCode.message}</FormErrorMessageSpan> : null}
                                    </div>
                                </Col>
                            </Row>

                            {(selectedFundNetAmount && !showSTPloader) && <p className="boldFont" style={{ marginTop: "6px" }}>Available Amount : <span className="greenText">₹ {selectedFundNetAmount?.toLocaleString(navigator.language, { minimumFractionDigits: 2 })} ({selectedFundNetUnit?.toLocaleString(navigator.language, { minimumFractionDigits: 2 })} Units)</span></p>}
                            <CustomisedHr />
                            <Row gutter={16}>
                                <Col xs={24} md={12}>
                                    <div className="form-group">
                                        <label htmlFor="freqType">Frequency of Transfer</label>
                                        <br />
                                        <select
                                            name='freqType'
                                            required
                                            style={{ marginTop: "4px" }}
                                            defaultValue={""}
                                            ref={register({
                                                required: "Please select the fund you want to transfer to.",
                                            })}
                                            onChange={(freq: any) => {
                                                setTransferFreq(freq.target.value);
                                                fetchSTPDates(freqObject[freq.target.value]);
                                            }}
                                        >
                                            <option value="" disabled>Select frequency</option>
                                            <option value="30" >Daily</option>
                                            <option value="52" >Weekly</option>
                                            <option value="1" >Monthly</option>
                                            <option value="3" >Quarterly</option>
                                        </select>
                                        {(errors?.freqType) ? <FormErrorMessageSpan>{errors.freqType.message}</FormErrorMessageSpan> : null}
                                        {dataUnavailableForFreq && <><CustomTag bgColor="#FFF8E8" fontSize='12'>
                                            <div className="STPerrorMsg"><ExclamationFilledIcon /><p><span>{dataUnavailableForFreq.toLowerCase()}</span> frequency is unavailable for this fund. Please choose another frequency.</p></div>
                                        </CustomTag><br /><br /></>}

                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <InputMintDiv>
                                        <label> Installment Amount</label>
                                        <br />
                                        <span className={getValues('installmentAmount') ? "input-symbol-rupee" : ""}>
                                            <input
                                                name='installmentAmount'
                                                onKeyUp={() => { getValues('noOfInstallments') !== "" && trigger('noOfInstallments'); }}
                                                type="number"
                                                placeholder="Enter amount"
                                                step="any"
                                                ref={register({
                                                    required: "Please enter amount for each installment",
                                                    validate: {
                                                        min: value => { return inputValidations?.minAmt && value >= inputValidations?.minAmt },
                                                        sourceMax: value => { return inputValidations?.maxAmt && value <= inputValidations?.maxAmt },
                                                        destinationMultplier: value => { return inputValidations?.multiplierAmt && (value / inputValidations?.multiplierAmt) % 1 === 0 }
                                                    }
                                                })}
                                            />
                                        </span>
                                        {
                                            (errors.installmentAmount && errors.installmentAmount.type === "min") &&
                                            <FormErrorMessageSpan>{`Minimum installment amount for STP is ${inputValidations?.minAmt}`}</FormErrorMessageSpan>
                                        }
                                        {
                                            (errors.installmentAmount && errors.installmentAmount.type === "sourceMax") &&
                                            <FormErrorMessageSpan>{`Maximum installment amount for STP is ${inputValidations?.maxAmt}`}</FormErrorMessageSpan>
                                        }
                                        {
                                            (errors.installmentAmount && errors.installmentAmount.type === "destinationMultplier") &&
                                            <FormErrorMessageSpan>{`Installment amount should be multiple of ${inputValidations.multiplierAmt}`}</FormErrorMessageSpan>
                                        }

                                        {(errors.installmentAmount) ? <FormErrorMessageSpan>{errors.installmentAmount.message}</FormErrorMessageSpan> : null}

                                    </InputMintDiv>
                                </Col>

                            </Row>

                            <Row gutter={16} >
                                {transferFreq != 30 && <Col xs={12} md={12}>
                                    <InputMintDiv>
                                        <label>No. of Installments</label>
                                        <br />
                                        <input
                                            name='noOfInstallments'
                                            style={{
                                                marginBottom: "10px"
                                            }}
                                            className="installInput"
                                            type="number"
                                            step="1"
                                            placeholder="Enter number"
                                            ref={register({
                                                required: "Please enter installments",
                                                pattern: {
                                                    value: /^(?:\d*)$/,
                                                    message: "Please enter valid installment number"
                                                },
                                                min: inputValidations?.minInstNo,
                                                validate: {
                                                    maxInstNo: value => { return inputValidations?.maxInstNo && value <= inputValidations?.maxInstNo },
                                                },
                                            })}
                                            onChange={e => setNumberOfInstallments(e.target.value)}

                                        />
                                        {
                                            (errors.noOfInstallments && errors.noOfInstallments.type === "min") &&
                                            <FormErrorMessageSpan>Minimum no. of installments is {inputValidations?.minInstNo}.</FormErrorMessageSpan>
                                        }
                                        {
                                            (errors.noOfInstallments && errors.noOfInstallments.type === "maxInstNo") &&
                                            <FormErrorMessageSpan>Maximum no. of installments is {inputValidations.maxInstNo}.</FormErrorMessageSpan>
                                        }


                                        {errors.noOfInstallments ? <FormErrorMessageSpan>{errors.noOfInstallments.message}</FormErrorMessageSpan> : null}
                                    </InputMintDiv>
                                </Col>}

                                <Col xs={12} md={12}>
                                    <label>Start Date</label><br />
                                    <Controller
                                        control={control}
                                        name='startDate'
                                        rules={{
                                            required: "Please enter start date.",
                                        }}
                                        render={({ onChange,value }) => (
                                            <DatePicker
                                                allowClear={false}
                                                format='DD/MM/YYYY'
                                                value={value}
                                                placeholder='DD/MM/YYYY'
                                                suffixIcon={<DatepickerIcon />}
                                                onChange={(date: any) => {
                                                    onChange(date);
                                                    setValue('endDate', '');
                                                    setEnteredDate(moment(date).format(dateFormat))
                                                }}
                                                style={{ height: "41px", margin: "4px 0 10px 0", width: "100%" }}
                                                disabledDate={date => disabledDates(date)}
                                            />
                                        )}
                                    />
                                    {errors.startDate ? <FormErrorMessageSpan>{errors.startDate.message}</FormErrorMessageSpan> : null}
                                </Col>

                                {transferFreq == 30 && <Col xs={12} md={12}>
                                    <label>End Date</label><br />
                                    <Controller
                                        control={control}
                                        name='endDate'
                                        rules={{
                                            required: "Please enter end date.",
                                            validate: {
                                                minDate: value => { return calcWeekDays(enteredDate, value) >= inputValidations?.minInstNo },
                                                maxDate: value => { return calcWeekDays(enteredDate, value) <= inputValidations?.maxInstNo },
                                            }
                                        }}
                                        render={({ onChange,value }) => (
                                            <DatePicker
                                                allowClear={false}
                                                format='DD/MM/YYYY'
                                                value={value}
                                                suffixIcon={<DatepickerIcon />}
                                                onChange={(endDt: any) => {
                                                    onChange(endDt);
                                                    setNumberOfInstallments(calcWeekDays(enteredDate, endDt));
                                                }}
                                                placeholder='DD/MM/YYYY'
                                                disabledDate={date => !date || date.isSameOrBefore(new Date()) || date.isBefore(enteredDate)}
                                                style={{ height: "41px", marginTop: "4px", width: "100%" }}
                                            />
                                        )}
                                    />

                                    {errors.endDate ? <FormErrorMessageSpan>{errors.endDate.message}</FormErrorMessageSpan> : null}
                                    {
                                        (errors.endDate && errors.endDate.type === "maxAmount") &&
                                        <FormErrorMessageSpan>Total STP amount should be less than or equal to available amount</FormErrorMessageSpan>
                                    }
                                    {
                                        (errors.endDate && errors.endDate.type === "minDate") &&
                                        <FormErrorMessageSpan>Minimum no. of installments is {inputValidations?.minInstNo}</FormErrorMessageSpan>
                                    }
                                    {
                                        (errors.endDate && errors.endDate.type === "maxDate") &&
                                        <FormErrorMessageSpan>Maximum no. of installments is {inputValidations?.maxInstNo}</FormErrorMessageSpan>
                                    }
                                </Col>}
                            </Row><br />
                            <Row>
                                <label>
                                    <Checkbox
                                        name="firstOrderToday"
                                        label={<span style={{ color: "black", lineHeight: "1.5" }}>
                                            Generate First Order Today
                                            <a
                                                onClick={() => setFirsrOrderTodayFlag(true)}
                                                style={{ color: "#0268ED" }}
                                            />{" "}
                                        </span>}
                                        checked={firstOrderTodayFlag}
                                        onChange={(e: any) => {
                                            setFirsrOrderTodayFlag(e.target.checked);
                                            Mixpanel.track(
                                                getEventName(
                                                    "firstOrderToday",
                                                    "clicked",
                                                    "checkout"
                                                )
                                            );
                                        }}
                                        className="firstOrderToday"
                                        checkboxRef={register}
                                    />
                                </label>
                            </Row>

                            <div className={isMobile ? "sticky-footer" : "btn-footer"}>
                                <Row gutter={16} >
                                    <Col xs={12} md={5}>
                                        <SuccessBtnWhiteGreenBorder width='100%' type="button" onClick={() => {
                                            history.push('/profile/stps');
                                            Mixpanel.track(getEventName("cancelledSTP", "clicked", "mySTPS"));
                                        }}>Cancel</SuccessBtnWhiteGreenBorder>
                                    </Col>
                                    <Col xs={12} md={7} style={{ paddingLeft: '0px' }}>
                                        <SubmitButton isMobile={isMobile} disabled={!formState.isValid} type="submit" >Setup New STP</SubmitButton>
                                    </Col>
                                </Row>
                            </div>
                        </form>
                    </Col>
                    <Col xs={0} md={4}> </Col>
                </Row>

                {showAwatingStatus && showAwaitingModal(awaitingClick)}

                {showConfirmPopup?.show && proceedAfterBseOrder(showConfirmPopup?.onClick, showConfirmPopup?.firstOrderToday, showConfirmPopup?.startDate)}

            </div>
        </PlanFormContainer>

    </div >);
};

export default CreateNewStp;

